import { useTranslation } from 'react-i18next';
import i18n from '@/lib/i18n';

interface TestData {
  id: string;
  title: string;
  description: string;
  icon: string;
}

export const useTestTranslations = () => {
  const { t } = useTranslation('training');

  const translateTest = (test: TestData, category: string, level: string = 'level3'): TestData => {
    const translationKey = `${level}.testData.${category}.${test.id}`;
    
    // Use i18n.t directly with namespace to ensure proper translation lookup
    const translatedTitle = i18n.t(`${translationKey}.title`, { ns: 'training', defaultValue: test.title });
    const translatedDescription = i18n.t(`${translationKey}.description`, { ns: 'training', defaultValue: test.description });
    
    console.log('=== Translation Debug ===');
    console.log('Translation key:', translationKey);
    console.log('Test ID:', test.id);
    console.log('Current language:', i18n.language);
    console.log('Original title:', test.title);
    console.log('Translated title:', translatedTitle);
    console.log('Are they equal?', translatedTitle === test.title);
    console.log('=========================');
    
    return {
      ...test,
      title: translatedTitle,
      description: translatedDescription
    };
  };

  const translateTests = (tests: TestData[], category: string, level: string = 'level3'): TestData[] => {
    return tests.map(test => translateTest(test, category, level));
  };

  return {
    translateTest,
    translateTests
  };
};